<template>
  <detail-with-icon class="stat-with-icon">
    <template #icon>
      <i :class="iconClass" />
    </template>
    <template #detail-text>
      <div v-if="!isNaN(number)">
        <span class="stat-number">{{ i18n.toNumber(number, {precision: 0}) }}</span>
        <span class="stat-label">{{ i18n.t(labelI18nKey, {count: number}) }}</span>
      </div>
    </template>
  </detail-with-icon>
</template>

<script>
import DetailWithIcon from '../components/detail-with-icon'

export default {
  components: { DetailWithIcon },

  props: {
    iconClass: {
      type: String,
      required: true
    },

    number: {
      type: Number,
      required: true
    },

    labelI18nKey: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
  .stat-with-icon {
    align-items: center;
  }
</style>
